import { useContext } from 'react';
import { ParentConnectionContext } from '../../components/ParentConnectionProvider';

export default function useParentConnectionContext() {
  const context = useContext(ParentConnectionContext);
  if (!context) {
    throw new Error('useParentConnectionContext must be used within a ParentConnectionProvider');
  }
  return context;
}
